export const AXN_COMPANY_ID_PATTERN = "axnCompanyId";
export const POLICY_COMPONENT_ID_PATTERN = "policyComponentId";
export const MESSAGING_TEMPLATE_ID_PATTERN = "messagingTemplateId";
export const MESSAGE_TEMPLATE_ID_PATTERN = "messageTemplateId";
export const WORKFLOW_ID_PATTERN = "workflowId";
export const RESET_USER_PASSWORD_EMAIL_PATTERN = "userEmail";
export const AXN_ADMIN_USER_ID_PATTERN = "axnAdminUserId"
export const IDENTITY_PROVIDER_ID_PATTERN = "identityProviderId";
export const RELYING_PARTY_ID_PATTERN = "relyingPartyId";
export const ORGANIZATION_INVITATION_ID_PATTERN = "axnAdminUserInvitationId";
export const SERVICE_TEMPLATE_ID_PATTERN = "serviceTemplateId";
export const AXN_ORGANIZATION_ID_PATTERN = "organizationId";
export const AXN_RELYING_PARTY_ID_PATTERN = "relyingPartyId";
export const REPORT_UID_PATTERN = "reportUid";